export default __webpack_public_path__ + "static/media/print-alert.568cd469.svg";